import {useMutation} from '@apollo/client'
import React, {useEffect} from 'react'
import {Button, Modal, Spinner} from 'react-bootstrap'
import {toast} from 'react-toastify'
import {parseId} from '../../../helpers'
import { DELETE_USER_DEDUCTION } from '../../../gql/mutations/userMutations'
import { IResDeleteCommisionDeductionTypes, IResDeleteCommissionUserDeduction } from '../../../types/users'
import { DELETE_USER_DEDUCTION_TYPE } from '../../../gql/mutations/userDeductionType'

interface IModalDeleteDeductionTypeProps {
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  infoEdit: {id: string}
}

export const ModalDeleteDeductionType: React.FC<IModalDeleteDeductionTypeProps> = ({
  infoEdit,
  isOpen,
  onClose,
  refetch,
}) => {
  const [gqlDeleteCommissionRate, {data, loading, error}] =
    useMutation<IResDeleteCommisionDeductionTypes>(DELETE_USER_DEDUCTION_TYPE)

  useEffect(() => {
    if (error) toast.error('Error: ' + error.message)
  }, [error])

  useEffect(() => {
    if (!data) return

    const res = data.CommissionDeductionTypeDelete

    if (res?.success) {
      toast.success('Success: Commission Deduction Type deleted successfully')
      onClose()
      refetch()
    } else if (res?.errors && res.errors.length > 0) {
      toast.error(`Error: ${res.errors[0]?.message || 'Something happened'}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleDelete = () => {
    gqlDeleteCommissionRate({
      variables: {
        id: parseId(infoEdit.id),
      },
    })
  }
  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Delete deduction type</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4 className='text-primary'>Are you sure you want to delete this record?</h4>
      </Modal.Body>
      <Modal.Footer>
        <Button size='sm' variant='secondary' onClick={onClose}>
          Cancel
        </Button>
        <Button
          size='sm'
          variant='danger'
          className='d-flex align-items-center'
          disabled={loading}
          onClick={handleDelete}
        >
          {loading && <Spinner animation='border' size='sm' />}
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
